// extracted by mini-css-extract-plugin
export default {"container":"Sq-z","brandName":"Tq-z","productName":"Uq-z","productNamePdpEnhancements":"Vq-z","breakLongProductName":"Wq-z"};